import { useEffect } from "react";
import { Helmet } from "react-helmet-async";

/**
 * Analytics & search-engine integration.
 * All IDs are read from process.env at build time; if empty, the scripts are no-ops.
 * Configure:
 *   REACT_APP_GA4_MEASUREMENT_ID   → e.g. G-XXXXXXX
 *   REACT_APP_GSC_VERIFICATION     → e.g. abc123def456... (google-site-verification content)
 *   REACT_APP_ADSENSE_CLIENT_ID    → e.g. ca-pub-0000000000000000
 */
export default function Analytics() {
  const ga4 = (process.env.REACT_APP_GA4_MEASUREMENT_ID || "").trim();
  const gsc = (process.env.REACT_APP_GSC_VERIFICATION || "").trim();
  const adsense = (process.env.REACT_APP_ADSENSE_CLIENT_ID || "").trim();

  useEffect(() => {
    if (!ga4) return;
    if (window.__gaLoaded__) return;
    window.__gaLoaded__ = true;
    const s = document.createElement("script");
    s.async = true;
    s.src = `https://www.googletagmanager.com/gtag/js?id=${ga4}`;
    document.head.appendChild(s);
    window.dataLayer = window.dataLayer || [];
    function gtag() { window.dataLayer.push(arguments); }
    window.gtag = gtag;
    gtag("js", new Date());
    gtag("config", ga4, { anonymize_ip: true });
  }, [ga4]);

  return (
    <Helmet>
      {gsc && <meta name="google-site-verification" content={gsc} />}
      {adsense && (
        <script
          async
          src={`https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js?client=${adsense}`}
          crossOrigin="anonymous"
        />
      )}
    </Helmet>
  );
}
